"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyResolver = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ClientTradingTokenManager_1 = require("../logicImpl/ClientTradingTokenManager");
const trade_utils_lib_1 = require("trade_utils_lib");
const signer_1 = require("../signer");
class KeyResolver {
    constructor() {
        this.clientTradingTokenManager = new ClientTradingTokenManager_1.ClientTradingTokenManager();
        this.signer = new signer_1.Signer(this.clientTradingTokenManager);
        let isInitDone = false;
        (0, trade_utils_lib_1.getTradeDependencyInstance)().multi.subscribe((status) => {
            ///> 数据初始化回调
            if (status === "init_done") {
                isInitDone = true;
                this.signer.init();
            }
        }, (error) => { });
        (0, trade_utils_lib_1.getTradeDependencyInstance)().appState.subscribe((state) => {
            if (state === trade_utils_lib_1.AppState.enterToForeground && isInitDone) {
                this.signer.updateRecvTimestamp();
            }
        }, (error) => { });
    }
    get requestSigner() {
        return this.signer;
    }
    get tradingTokenManager() {
        return this.clientTradingTokenManager;
    }
    /**
     * 上传apiKey
     * @param apiKey
     */
    uploadApiKeyInfo(apiKey) {
        if (apiKey.market === "pionex.v2") {
            return (0, rxjs_1.of)({
                result: !apiKey.cloudKeyId,
                keyId: apiKey.cloudKeyId,
                msg: "",
            });
        }
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.map)((token) => {
            return {
                token: token,
            };
        }), (0, operators_1.mergeMap)((result) => {
            return (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getRSAPublicKey()
                .pipe((0, operators_1.map)((rsaKey) => {
                result["rsaPublicKey"] = rsaKey;
                return result;
            }));
        }), (0, operators_1.mergeMap)((result) => {
            if (!result["token"] || !result["rsaPublicKey"]) {
                return (0, rxjs_1.of)({
                    result: false,
                    keyId: "",
                });
            }
            let encodeString = "";
            if (apiKey.extra) {
                encodeString = `${apiKey.key}|||${apiKey.secret}|||${apiKey.extra}`;
            }
            else {
                encodeString = `${apiKey.key}|||${apiKey.secret}`;
            }
            ///> 单次加密的最大长度是245个字符
            if (encodeString.length > 245) {
                let currentIndex = 0;
                let encodeResult = "";
                while (currentIndex < encodeString.length) {
                    const encodeRow = (0, trade_utils_lib_1.encryptWithRSAKey)(result["rsaPublicKey"], encodeString.substr(currentIndex, 245));
                    if (encodeResult) {
                        encodeResult += "|||";
                    }
                    encodeResult += encodeRow;
                    currentIndex += 245;
                }
                encodeString = encodeResult;
            }
            else {
                encodeString = (0, trade_utils_lib_1.encryptWithRSAKey)(result["rsaPublicKey"], encodeString);
            }
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/key/save`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam), {
                Authorization: result["token"],
                "Content-Type": "application/json;charset=UTF-8",
            }, {
                exchange: apiKey.market,
                alias: "",
                secret: encodeString,
            }, (response) => {
                return response;
            }).pipe((0, operators_1.map)((uploadResult) => {
                if (uploadResult["code"] === 0) {
                    return {
                        result: uploadResult["code"] === 0,
                        keyId: uploadResult["data"]["key_id"],
                    };
                }
                else {
                    return {
                        result: false,
                        keyId: "",
                        msg: JSON.stringify(uploadResult),
                    };
                }
            }));
        }));
    }
    /**
     * 从远端删除key
     * @param keyId
     */
    deleteKeyFromCloud(keyId) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)(false);
            }
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/key/delete`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam), {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            }, {
                key_id: keyId,
            }, (response) => {
                return response;
            })
                .pipe((0, operators_1.map)((uploadResult) => {
                return uploadResult["code"] === 0;
            }))
                .pipe((0, operators_1.catchError)((err) => {
                if (err.code === -3) {
                    ///> 服务端已经不存在这个key了
                    return (0, rxjs_1.of)(true);
                }
                return (0, rxjs_1.of)(false);
            }));
        }));
    }
    /**
     * 从云端获取key信息
     */
    getAllCloudApiKeyInfo() {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)([]);
            }
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/key/get_all`, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam), {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            }, (response) => {
                return response;
            })
                .pipe((0, operators_1.map)((result) => {
                if (result.code === 0) {
                    return result.data;
                }
                else {
                    return [];
                }
            }))
                .pipe((0, operators_1.catchError)(() => {
                return (0, rxjs_1.of)([]);
            }));
        }));
    }
    /**
     * 上传key并且刷新数据库
     */
    uploadApiKeyRefreshLocal(apiKey) {
        return this.uploadApiKeyInfo(apiKey).pipe((0, operators_1.mergeMap)((uploadResult) => {
            if (uploadResult.result && (0, trade_utils_lib_1.getTradeDependencyInstance)().refreshApiCloudKeyId) {
                return (0, trade_utils_lib_1.getTradeDependencyInstance)()
                    .refreshApiCloudKeyId(uploadResult.keyId, apiKey.key)
                    .pipe((0, operators_1.map)(() => {
                    return uploadResult;
                }));
            }
            return (0, rxjs_1.of)(uploadResult);
        }), (0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)({
                result: false,
                keyId: "",
                msg: JSON.stringify(err),
            });
        }));
    }
}
exports.KeyResolver = KeyResolver;
